import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlackoutService {
  private apiUrl = `${environment.baseUrl}properties-blackout`;

  constructor(private http: HttpClient) {}

  getBlackouts(propertyId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${propertyId}`);
  }

  getTenantBlackouts(propertyId: string, tenantUserId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${propertyId}`, { params: { tenantUserId } });
  }

  createBlackout(propertyId: string, payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${propertyId}`, payload);
  }

  updateBlackout(blackoutId: string, payload: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/${blackoutId}`, payload);
  }

  deleteBlackout(blackoutId: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${blackoutId}`);
  }
}